import React from 'react';
import InfoBlockItem from './InfoBlockItem';
import { ClubLink } from './types/clubLinksTypes';
import { useClubContext } from './hooks/ClubContext';
import { useHeaderContext } from 'Components/HeaderContext';

const InfoBlockItemHelpcenter = (): JSX.Element => {
    const { t } = useHeaderContext();
    const { links } = useClubContext();

    return (
        <InfoBlockItem
            text={t('OwwHeader_Customer Service')}
            testId="oww-header-info-block-helpcenter"
            trackingLabel="Contact"
            url={links[ClubLink.HELPCENTER].path}
        />
    );
};

export default InfoBlockItemHelpcenter;
